export type languageCode = 'en' | 'af';

export const BIRTHDAY_EMAIL_TEMPLATES: Record<
  languageCode,
  { subject: string; body: string }
> = {
  en: {
    subject: 'Celebrating You Today: Happy Birthday!',
    body: 'Happy birthday, {{toName}},\n\nWishing you a wonderful birthday and a year ahead filled with happiness and success.\n\nBest wishes,\n{{fromName}}',
  },
  af: {
    subject: 'Vier Jou Vandag: Gelukkige Verjaarsdag!',
    body: "Gelukkige verjaarsdag, {{toName}},\n\nEk wens jou 'n wonderlike verjaarsdag toe en 'n jaar vol geluk en sukses.\n\nBeste wense,\n{{fromName}}",
  },
};
